import {ChatOverlaySectionAction, TOGGLE_CHAT_OVERLAY, ToggleChatOverlay} from "../actions";
import {TypeUtils} from "../../shared/utils/type-utils";

export interface IChatOverlaySectionState {
  toggled: boolean;
}

export const initialState: IChatOverlaySectionState = {
  toggled: false
};


export function reducer(state: IChatOverlaySectionState = initialState, action: ChatOverlaySectionAction): IChatOverlaySectionState {
  switch (action.type) {

    case TOGGLE_CHAT_OVERLAY:
      let toggled: boolean = (<ToggleChatOverlay>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
